module.exports = __webpack_public_path__ + "static/media/Template_urgent_regular_EDLP.7c8aca26.csv";